<template>
  <van-popup v-model="show" class="van-popup-class" :close-on-click-overlay="false">
    <div class="info">
      <h4>请先设定头像和昵称</h4>
      <img @click="close" class="close" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/%E5%85%B3%E9%97%AD.svg"/>
      <div class="info-img">
         <input type="file" @change="uploadFile" class="input">
        <img class="base" @click="getRandomAvater" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/transparent-circle.svg"/>
        <img
          class="avater"
          v-lazy="`${avatar}?x-oss-process=image/resize,m_fill,w_128,h_128`"
        />
        <img class="camera" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/camera.svg" />
        <div class="block" @click="getRandomAvater">
          换一张
        </div>
      </div>
      <div class="nickname">
        <input v-model="nickName" :placeholder="placeholder" />
        <div class="reload" @click="getRandomNickName">
          <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/sync.svg"/>
        </div>
      </div>
      <button @click="editUser">提交</button>
    </div>
  </van-popup>
</template>
<script>
import { Popup } from 'vant'
import { putFile, get, post } from '../utils/request'
import { get as getUser, set } from '../utils/token'
export default {
  components: {
    'van-popup': Popup
  },
  created () {
    this.getRandomAvater()
    this.getRandomNickName()
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      avatar: '',
      nickName: '',
      placeholder: ''
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    editUser () {
      const user = getUser('user')
      const nickName = this.nickName ? this.nickName : this.placeholder
      const promise = post({
        url: '/user/addRole',
        data: {
          phoneNumber: user ? user.phoneNumber : '',
          nickName: nickName,
          avatar: this.avatar
        }
      })
      promise.then(res => {
        const { data: { code } } = res
        if (Object.is(code, 200)) {
          if (user) {
            user.nickName = nickName
            user.avatar = this.avatar
          }
          this.$emit('close')
          set('user', user)
        } else {
        }
      })
    },
    uploadFile (e) {
      const promise = putFile({
        url: '/bbs/uploadFile',
        file: e.target.files[0]
      })
      promise.then(res => {
        const { status, data: { data } } = res
        if (Object.is(status, 200)) {
          this.avatar = data[0]
        }
      })
    },
    getRandomNickName () {
      const promise = get({
        url: '/user/generateNickname'
      })
      promise.then(res => {
        const { data: { nickName }, status } = res
        if (Object.is(status, 200)) {
          this.nickName = ''
          this.placeholder = nickName
        }
      })
    },
    getRandomAvater () {
      const promise = get({
        url: '/user/chooseAvatar'
      })
      promise.then(res => {
        const { data: { avatarUrl }, status } = res
        if (Object.is(status, 200)) {
          this.avatar = avatarUrl
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.van-popup-class {
  border-radius: 8px;
  background: rgba(255, 255, 255, 1);
  .info {
    width: 327px;
    margin: 0 auto;
    height: 380px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
    .close {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 18px;
      height: 18px;
    }
    h4 {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 1);
      line-height: 28px;
    }
    .info-img {
      position: relative;
      margin-top: 12px;
      width: 132px;
      height: 132px;
      .base {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9;
      }
      .avater {
        position: absolute;
        top: 16px;
        left: 16px;
        width: 100px;
        height: 100px;
      }
      .camera, input {
        position: absolute;
        top: 13px;
        right: 13px;
        width: 28px;
        height: 28px;
        z-index: 11;
      }
      input {
        z-index: 12;
        opacity: 0;
      }
      .block {
        position: absolute;
        bottom: 16px;
        left: 16px;
        width:100px;
        text-align: center;
        line-height: 22px;
        height:22px;
        background:rgba(0,0,0,0.5);
        z-index: 8;
        font-size:10px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
      }
    }
    .nickname {
      margin-top: 8px;
      width:212px;
      height:44px;
      background:rgba(245,245,245,1);
      border-radius:22px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      padding-left: 22px;
      input {
        background:rgba(245,245,245,1);
        border: none;
        outline: none;
        width: 147px;
      }
      .reload {
        width:44px;
        height:44px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width:13px;
          height:13px;
        }
      }
      ::-webkit-input-placeholder {
          font-size:17px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(136,136,136,1);
          line-height:24px;
        }
    }
    button {
      font-size:17px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(255,255,255,1);
      line-height:24px;
      width:132px;
      height:44px;
      background:rgba(24,204,159,1);
      border-radius:4px;
      box-sizing: border-box;
      margin-top: 48px;
      border: none;
      outline: none;
    }
  }
}
</style>
